<template lang="pug">
  div
    section.content-header
      h1 パスワードポリシー
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active パスワードポリシー

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル
        +btnbar

        .box.box-widget
          .box-header.with-border
            .box-title パスワードの有効期限

          .box-body
            .form-group
              label.control-label 有効期限
              .checkbox
                label
                  input(type="checkbox" v-model="pwdlimit_use")
                  | 有効期限を適用する。

              .form-inline
                .form-group
                  label 日数&nbsp;:&nbsp;
                  input.form-control(type="number" min="1" max="999" v-model="pwdlimit" :disabled="!pwdlimit_use")

              .help-block
                p.bcard-comments.text-info
                  | ※ 指定した日数以内にパスワードを変更する必要があります。<br>
                  | チェックして「日数」を指定しない場合、"1"が指定されたものとして扱います。

            hr

            .form-group
              label.control-label 警告期間
              .checkbox
                label
                  input(type="checkbox" v-model="pwdwarning_use")
                  | 期限が切れる前に、警告を表示する。

              .form-inline
                .form-group
                  label 日数&nbsp;:&nbsp;
                  input.form-control(type="number" min="1" max="999" v-model="pwdwarning" :disabled="!pwdwarning_use")

              .help-block
                p.bcard-comments.text-info
                  | ※ パスワードの期限が切れる前に、指定した日数で警告を表示します。<br>
                  | チェックして「日数」を指定しない場合、"1"が指定されたものとして扱います。

            hr

            .checkbox
              label
                input(type="checkbox" v-model="pwdlimitadmin_use")
                | システム管理者は無期限とする。

            .help-block
              p.bcard-comments.text-info
                | ※ チェックした場合、システム管理者は有効期限が無期限になります。

        .box.box-widget
          .box-header.with-border
            .box-title パスワードの入力規則

          .box-body
            .form-group
              label.control-label 最低文字数
              .checkbox
                label
                  input(type="checkbox" v-model="requisite_min_use")
                  | 最低文字数を適用する。

              .form-inline
                .form-group
                  label 文字数&nbsp;:&nbsp;
                  input.form-control(type="number" min="1" max="99" v-model="pass_requisite_min" :disabled="!requisite_min_use")

              .help-block
                p.bcard-comments.text-info
                  | ※ 指定された文字数以上の文字をパスワードに設定する必要があります。<br>
                  | チェックして「文字数」を指定しない場合、"1"が指定されたものとして扱います。

            hr

            .form-group
              label.control-label 文字種
              p.form-control-static 文字種毎の文字数制限を入力してください。

                .form-horizontal
                  .form-group
                    label.control-label.col-sm-2(for="") 数字
                    .col-sm-10
                      .checkbox
                        label
                          input(type="checkbox" v-model="digit_credit_use")
                          | 数字の文字数を適用する。

                        .form-inline
                          .form-group
                            label 文字数&nbsp;:&nbsp;
                            input.form-control(type="number" min="1" max="99" v-model="pass_digit_credit" :disabled="!digit_credit_use")

                        .help-block
                          p.bcard-comments.text-info
                            | ※ 指定した文字数以上の数字（0～9）をパスワードに設定する必要があります。<br>
                            | チェックして「文字数」を指定しない場合、"1"が指定されたものとして扱います。

                    label.control-label.col-sm-2 英大文字
                    .col-sm-10
                      .checkbox
                        label
                          input(type="checkbox" v-model="upper_credit_use")
                          | 英大文字の文字数を適用する。

                        .form-inline
                          .form-group
                            label 文字数&nbsp;:&nbsp;
                            input.form-control(type="number" min="1" max="99" v-model="pass_upper_credit" :disabled="!upper_credit_use")

                        .help-block
                          p.bcard-comments.text-info
                            | ※ 指定した文字数以上の英大文字（A～Z）をパスワードに設定する必要があります。<br>
                            | チェックして「文字数」を指定しない場合、"1"が指定されたものとして扱います。

                    label.control-label.col-sm-2(for="") 英小文字
                    .col-sm-10
                      .checkbox
                        label
                          input(type="checkbox" v-model="lower_credit_use")
                          | 英小文字の文字数を適用する。

                        .form-inline
                          .form-group
                            label 文字数&nbsp;:&nbsp;
                            input.form-control(type="number" min="1" max="99" v-model="pass_lower_credit" :disabled="!lower_credit_use")

                        .help-block
                          p.bcard-comments.text-info
                            | ※ 指定した文字数以上の英小文字（a～z）をパスワードに設定する必要があります。<br>
                            | チェックして「文字数」を指定しない場合、"1"が指定されたものとして扱います。

                    label.control-label.col-sm-2 記号
                    .col-sm-10
                      .checkbox
                        label
                          input(type="checkbox" v-model="other_credit_use")
                          | 記号の文字数を適用する。

                        .form-inline
                          .form-group
                            label 文字数&nbsp;:&nbsp;
                            input.form-control(type="number" min="1" max="99" v-model="pass_other_credit" :disabled="!other_credit_use")

                        .help-block
                          p.bcard-comments.text-info
                            | ※ 指定した文字数以上の記号をパスワードに設定する必要があります。<br>
                            | チェックして「文字数」を指定しない場合、"1"が指定されたものとして扱います。

                    .row
                      .col-sm-offset-2.col-sm-10
                        hr

                    label.control-label.col-sm-2 使用禁止文字
                    .col-sm-10
                      .checkbox
                        label
                          input(type="checkbox" v-model="prohibited_characters_use")
                          | 使用禁止文字を適用する。

                        .form-inline
                          .form-group
                            label 文字&nbsp;:&nbsp;
                            input.form-control(type="text" v-model="pass_prohibited_characters" :disabled="!prohibited_characters_use" :maxlength="maxlengths.pass_prohibited_characters")

                        .help-block
                          p.bcard-comments.text-info
                            | ※ パスワードに設定できない文字を指定します。<br>
                            | 例）"abc"と入力した場合、a, b, cの文字はパスワードに使用できません。

        .box.box-widget
          .box-header.with-border
            .box-title パスワードの変更規則

          .box-body
            .form-group
              label.control-label(for="") 変更時の相違文字数
              .checkbox
                label
                  input(type="checkbox" v-model="different_modify_use")
                  | パスワード変更時の相違文字数を適用する。

              .form-inline
                .form-group
                  label 文字数&nbsp;:&nbsp;
                  input.form-control(type="number"  min="1" max="99" v-model="pass_different_modify" :disabled="!different_modify_use")

              .help-block
                p.bcard-comments.text-info
                  | ※ 変更後のパスワードは、現在のパスワードで使用していない文字を、指定された文字数以上使用する必要があります。<br>
                  | チェックして「文字数」を指定しない場合、"1"が指定されたものとして扱います。

            hr

            .form-group
              label.control-label 再利用禁止
              .checkbox
                label
                  input(type="checkbox" v-model="remember_use" checked="")
                  | 過去に使用したパスワードへの変更を禁止する回数を適用する。

              .form-inline
                .form-group
                  label 回数&nbsp;:&nbsp;
                  input.form-control(type="number"  min="1" max="9" v-model="pass_remember" :disabled="!remember_use")

              .help-block
                p.bcard-comments.text-info
                  | ※ 指定された回数の間は、同じパスワードを設定できません。<br>
                  | チェックして「回数」を指定しない場合、"1"が指定されたものとして扱います。<br>
                  | 本設定が有効で、「回数」に"2"が指定された場合、例えばパスワードに"abc"が設定されていると、 3 回目 のパスワード変更から"abc"が設定できるようになります。

        .box.box-widget
          .box-header.with-border
            .box-title ユーザーのログイン拒否

          .box-body
            .form-group
              label.control-label 再試行回数
              .checkbox
                label
                  input(type="checkbox" v-model="login_lock_use")
                  | ログイン再試行回数を適用する。

              .form-inline
                .form-group
                  label 回数&nbsp;:&nbsp;
                  input.form-control(type="number" min="1" max="10" v-model="login_failures_permitted" :disabled="!login_lock_use")
                | &nbsp;
                .form-group
                  label 解除時間(分)&nbsp;:&nbsp;
                  input.form-control(type="number" min="10" max="9999" v-model="login_lock_reset_time" :disabled="!login_lock_use")

              .help-block
                p.bcard-comments.text-info
                  | ※ 指定された回数を超えて、連続でログインに失敗するとログイン拒否の状態になります。<br>
                  | チェックして「回数」を指定しない場合、"5"が指定されたものとして扱います。「解除時間(分)」を指定しない場合、"10"が指定されたものとして扱います。<br>
                  | 以下の操作でログイン拒否が解除されます。<br>
                  | ・「解除時間(分)」で指定した時間(分)が経過する。<br>
                  | ・[ユーザー管理]にて、[ログイン拒否の解除]を行う。<br>
                  | ・ユーザーのパスワードを変更する。<br>

        +btnbar(class="-bottom")

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PasswordPolicyRepository = RepositoryFactory.get('passwordpolicy')

export default {
  name: 'Corporates',
  components: { AppMessages },
  data: function () {
    return {
      pwdlimit: '',
      pwdwarning: '',
      pwdlimitadmin: '',
      pass_requisite_min: '',
      pass_digit_credit: '',
      pass_upper_credit: '',
      pass_lower_credit: '',
      pass_other_credit: '',
      pass_prohibited_characters: '',
      pass_different_modify: '',
      pass_remember: '',
      login_failures_permitted: '',
      login_lock_reset_time: '',

      // 適用フラグ
      pwdlimit_use: false,
      pwdwarning_use: false,
      pwdlimitadmin_use: false,
      requisite_min_use: false,
      digit_credit_use: false,
      upper_credit_use: false,
      lower_credit_use: false,
      other_credit_use: false,
      prohibited_characters_use: false,
      different_modify_use: false,
      remember_use: false,
      login_lock_use: false,

      isLoading: true, // 読み込み中かどうか
      maxlengths: {}
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('LoginSettings')
    const vm = this

    // API実行
    PasswordPolicyRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        // ログイン管理
        vm.pass_requisite_min = data.pass_requisite_min
        vm.pass_digit_credit = data.pass_digit_credit
        vm.pass_upper_credit = data.pass_upper_credit
        vm.pass_lower_credit = data.pass_lower_credit
        vm.pass_other_credit = data.pass_other_credit
        vm.pass_prohibited_characters = data.pass_prohibited_characters
        vm.pass_different_modify = data.pass_different_modify
        vm.pass_remember = data.pass_remember
        // 会社情報
        vm.pwdlimit = data.pwdlimit
        vm.pwdwarning = data.pwdwarning
        vm.pwdlimitadmin = data.pwdlimitadmin
        vm.login_failures_permitted = data.login_failures_permitted
        vm.login_lock_reset_time = data.login_lock_reset_time

        // 適用フラグ初期化
        vm.pwdlimit_use = vm.isset(vm.pwdlimit)
        vm.pwdwarning_use = vm.isset(vm.pwdwarning)
        vm.pwdlimitadmin_use = (vm.pwdlimitadmin !== vm.app_flag.ON)
        vm.requisite_min_use = vm.isset(vm.pass_requisite_min)
        vm.digit_credit_use = vm.isset(vm.pass_digit_credit)
        vm.upper_credit_use = vm.isset(vm.pass_upper_credit)
        vm.lower_credit_use = vm.isset(vm.pass_lower_credit)
        vm.other_credit_use = vm.isset(vm.pass_other_credit)
        vm.prohibited_characters_use = vm.isset(vm.pass_prohibited_characters)
        vm.different_modify_use = vm.isset(vm.pass_different_modify)
        vm.remember_use = vm.isset(vm.pass_remember)
        vm.login_lock_use = vm.isset(vm.login_failures_permitted) && vm.isset(vm.login_lock_reset_time)

        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  methods: {
    // パスワードポリシーの登録・更新
    postData () {
      const vm = this

      // パラメータ
      const data = {
        pwdlimit: this.replaceValue(this.pwdlimit_use, this.pwdlimit, 1),
        pwdwarning: this.replaceValue(this.pwdwarning_use, this.pwdwarning, 1),
        pwdlimitadmin: this.pwdlimitadmin_use ? this.app_flag.OFF : this.app_flag.ON,
        pass_requisite_min: this.replaceValue(this.requisite_min_use, this.pass_requisite_min, 1),
        pass_digit_credit: this.replaceValue(this.digit_credit_use, this.pass_digit_credit, 1),
        pass_upper_credit: this.replaceValue(this.upper_credit_use, this.pass_upper_credit, 1),
        pass_lower_credit: this.replaceValue(this.lower_credit_use, this.pass_lower_credit, 1),
        pass_other_credit: this.replaceValue(this.other_credit_use, this.pass_other_credit, 1),
        pass_prohibited_characters: this.prohibited_characters_use ? this.pass_prohibited_characters : null,
        pass_different_modify: this.replaceValue(this.different_modify_use, this.pass_different_modify, 1),
        pass_remember: this.replaceValue(this.remember_use, this.pass_remember, 1),
        login_failures_permitted: this.replaceValue(this.login_lock_use, this.login_failures_permitted, 5),
        login_lock_reset_time: this.replaceValue(this.login_lock_use, this.login_lock_reset_time, 10)
      }

      // API実行
      PasswordPolicyRepository.put(data)
        .then(function () {
        // 成功時は設定状況に遷移
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
          // エラー時はメッセージを表示
          scrollTo(0, 0)
          vm.setErrorMessage(error)
        })
    },
    // nullまたは未定義の場合にfalseを返す
    isset (value) {
      return !((typeof value === 'undefined') || (value === null))
    },
    // フラグに応じた値を返す
    replaceValue (flag, value, def) {
      // フラグがオフならnullを返す
      if (!flag) {
        return null
      }
      // フラグががオンで値が無い場合は既定値を返す
      else if (flag && (value === '' || value === null)) {
        return def
      }
      // フラグがオンで値がnull以外ならそのまま値を返す
      else {
        return value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/Passwordpolicy.vue